"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeElementsDefaultChildren = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
exports.AttributeElementsDefaultChildren = function (_a) {
    var validElements = _a.validElements, loadMore = _a.loadMore, isLoading = _a.isLoading, error = _a.error;
    if (error) {
        return react_1.default.createElement("div", null, error);
    }
    var _b = validElements || {}, offset = _b.offset, limit = _b.limit;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("p", null,
            "Use children function to map ",
            "{",
            " validElements, loadMore, isLoading, error ",
            "} ",
            "to your React components."),
        react_1.default.createElement("button", { className: "gd-button gd-button-secondary", onClick: loadMore, disabled: isLoading }, "More"),
        react_1.default.createElement("h2", null, "validElements"),
        react_1.default.createElement("pre", null,
            "isLoading: ",
            isLoading.toString(),
            "offset: ",
            offset,
            "limit: ",
            limit,
            "validElements:",
            JSON.stringify(validElements, null, "\t"))));
};
//# sourceMappingURL=AttributeElementsDefaultChildren.js.map